import ManagePlanPage from './ManagePlanPage'

export default ManagePlanPage
